import React, { useEffect, useState } from 'react';
import { DialogTitle } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useSnackbar } from 'notistack';
import { IKSKDebtModel } from 'interfaces';
import { getKSKDebt } from './api';
import DebtDetail from './components/DebtDetail';

interface IUsoDebtDialogProps {
  open: boolean;
  /** GUID контрагента-владельца помещения */
  kontragentGuid: string;
  /** GUID помещения */
  roomGuid: string;
  /** GUID договора (для скачивания акта сверки) */
  contractGuid?: string;
  /** GUID ЖК (для скачивания акта сверки) */
  realEstateGuid?: string;
  /** Имя контрагента (для заголовка) */
  kontragentName?: string;
  /** Имя помещения (для заголовка) */
  roomName?: string;
  onClose(): void;
}

const UsoDebtDialog: React.FC<IUsoDebtDialogProps> = ({
  open,
  kontragentGuid,
  roomGuid,
  contractGuid,
  realEstateGuid,
  kontragentName,
  roomName,
  onClose,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [info, setInfo] = useState<IKSKDebtModel | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !kontragentGuid || !roomGuid) return;

    setLoading(true);
    getKSKDebt(roomGuid, kontragentGuid)
      .then(setInfo)
      .catch((error) => {
        setInfo(null);
        enqueueSnackbar(
          error?.response?.data?.message || 'Ошибка загрузки данных о задолженности',
          { variant: 'error' },
        );
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, kontragentGuid, roomGuid]);

  useEffect(() => {
    if (!open) setInfo(null);
  }, [open]);

  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={onClose}>
      <DialogTitle>
        <b>Долг по УСО</b>
      </DialogTitle>

      <DialogContent dividers>
        <DebtDetail
          label={kontragentName || ''}
          subLabel={roomName ? `Помещение: ${roomName}` : ''}
          info={info}
          loading={loading}
          realEstateGuid={realEstateGuid}
          contractGuid={contractGuid}
          ownerGuid1c={kontragentGuid}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UsoDebtDialog;
